// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".privacy-form__input{margin-bottom:30px}.privacy-form__select{margin-bottom:30px}.privacy-form__container{margin-top:30px}.privacy-form__top-disclaimer{font-size:12px;color:#373a36;text-align:end}.privacy-form__bottom-disclaimer{margin-bottom:15px;margin-top:15px}.privacy-form__textarea{margin-bottom:30px}", ""]);
// Exports
module.exports = exports;
